import React from 'react';
import './About.css';

function About() {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-content">
          <h2>About CASHU</h2>
          <div className="about-text">
            <p>
              With over 12+ years of experience in processing premium cashews, CASHU has established
              itself as a trusted name in the cashew industry. Our commitment to quality, sustainability,
              and innovation drives everything we do.
            </p>
            <p>
              We source our cashews directly from the finest farms and employ traditional processing
              methods combined with modern technology to ensure every kernel meets our exacting standards.
              From careful selection to meticulous processing, we maintain the natural goodness and
              exceptional taste that makes our cashews truly premium.
            </p>
          </div>
        </div>
        <div className="about-image">
          <img src="/bowl.png" alt="Premium Cashew Bowl" />
        </div>
      </div>
    </section>
  );
}

export default About;